// Helpers to pick the Chinese variant of portfolio category/title when the
// active language is Chinese, falling back to English.

export const isZh = (lang?: string) => !!lang && lang.toLowerCase().startsWith('zh');

export const localizedName = (
  item: { nameEn: string; nameCn?: string },
  lang?: string,
): string => (isZh(lang) && item.nameCn ? item.nameCn : item.nameEn);

export const localizedTitle = (
  item: { title: string; titleCn?: string },
  lang?: string,
): string => (isZh(lang) && item.titleCn ? item.titleCn : item.title);
